import * as React from "react";
import TextField from "@mui/material/TextField";
import AdapterJalali from "@date-io/date-fns-jalali";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import MDInputRoot from "components/MDInput/MDInputRoot";
import MDTypography from "components/MDTypography";
import moment from "jalali-moment";
export default function MDatepicker({ label }) {
  const [selectedDate, setSelectedDate] = React.useState(
new Date()
  );

  const renderInput = (props) => (
    <>
      <MDTypography fontSize="xs" pb={1} pl={0.5}>
        {label}
      </MDTypography>
      <MDInputRoot
        type="text"
        inputRef={props.inputRef}
        inputProps={props.inputProps}
        value={moment(selectedDate).locale("fa").format("YYYY/MM/DD") }
        onClick={props.onClick}
        onChange={setSelectedDate}
        endAdornment={props.InputProps?.endAdornment}
      />
    </>
  );
  return (
    <LocalizationProvider dateAdapter={AdapterJalali}>
      <DatePicker
      
        mask="____/__/__"
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        value={selectedDate}
        onChange={setSelectedDate}
        renderInput={renderInput}
      />
    </LocalizationProvider>
  );
}
